import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkFlow } from 'src/app/enum/water-lab/workFlow';
import { AccessUserInfo, PrintLabelSummary, UserDetail } from 'src/app/models';
import { LabRequisitionService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { MessageService } from 'src/app/services/toaster/message.service'
var pdfMake = require("pdfmake/build/pdfmake");
var pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.vfs;
var htmlToPdfmake = require("html-to-pdfmake");

@Component({
  selector: 'bart-print-label-summary',
  templateUrl: './print-label-summary.component.html',
  styleUrls: ['./print-label-summary.component.scss']
})
export class PrintLabelSummaryComponent implements OnInit {
  @Input() printLabelSummaryResponse: PrintLabelSummary[] = [];
  @Input() facilityDetails: any;
  @Input() workFlow: string;
  @Input() facilityDisplayName: string;
  @Input() acutePrinterMode:string="";
  @Input() isPrintFromPendingManifest:boolean=false;
  @Output() labelPrintingCompletedEvent = new EventEmitter();
  printRequisitionColumns: any = [];
  pageCount: number;
  containerCount: number;
  labelCount: number;
  requisitionCount: number;
  LabelsPerRow = [1, 2];
  //Ng-Barcode properties
  elementType = 'svg';
  format = 'CODE128A';
  lineColor = '#000000';
  width = 1;
  height = 30;
  displayValue = true;
  fontOptions = '';
  font = 'monospace';
  textAlign = 'center';
  textPosition = 'bottom';
  textMargin = 0;
  fontSize = 10;
  background = '#ffffff';
  margin = 0;
  marginTop = 0;
  marginBottom = 0;
  marginLeft = 0;
  marginRight = 0;
  //End

  printPDFData: any[] = [];
  printAcutePDFData: any[] = [];
  userInfo: UserDetail;
  public ENUM_WORKFLOW = WorkFlow;
  constructor(private _loaderService: LoaderService, private _requisitionService:LabRequisitionService,private _messageService: MessageService) { }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.printRequisitionColumns =
      [
        { field: 'ModelNumber', header: 'Model #', display: 'table-cell', width: "20%" },
        { field: 'EquipmentID', header: 'Equipment ID', display: 'table-cell', width: "10%" },
        { field: 'EquipmentSerialNumber', header: 'Serial #', display: 'table-cell', width: "15%" },
        { field: 'LabRequestID', header: 'Request ID', display: 'table-cell', width: "8%" },
        { field: 'RequisitionNumber', header: 'Requisition ID', display: 'table-cell', width: "12%" },
        { field: 'TestDisplayName', header: 'Test ID | Name', display: 'table-cell', width: "25%" },
        { field: 'ContainerID', header: 'Container ID', display: 'table-cell', width: "10%" }
      ];

    let count = this.printLabelSummaryResponse.length / 8;
    this.pageCount = Math.ceil(count);
    let printTableData = [];
    let printLabelData = [];
    let printZPLdata=[]
    printTableData = this.printLabelSummaryResponse.filter(x => x.IsSWAB != true);
    printLabelData = this.printLabelSummaryResponse;
    printZPLdata=Object.assign([],this.printLabelSummaryResponse)
    this.containerCount = printLabelData.length;
    //Start:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268] 
    let isSpecialEdgeCaseCount=printTableData.filter(x=>x.TestDisplayName.startsWith("0386 |") || x.TestDisplayName.startsWith("0387 |")).length;
    if(isSpecialEdgeCaseCount>0)
    {
      this.containerCount=this.containerCount+isSpecialEdgeCaseCount;
    }
    //End:PCR-007.1: Lab NEW Requirement - Lab New Profile Code 0386 [FREQ-774268] 
    this.labelCount = printLabelData.length;
    this.requisitionCount = printTableData.length;

    printTableData = this.chunks(printTableData, 8);
    printLabelData = this.chunks(printLabelData, 8);
    
      // this.printAcutePDFData=printLabelData; 
      if(this.acutePrinterMode=="network"){
        //this.printAcutePDFData=printLabelData; 
        for (let i = 0; i <= printLabelData.length - 1; i++) {
          let lblData = this.chunks(printLabelData[i], 4);
          this.printPDFData.push({ pdfTableData: printTableData[i], pdfLabelData: lblData });
        }
        this.createPDF();
      }
      else{
        let printLabelDataTemp = [];
        printLabelDataTemp = printZPLdata;
        let ZplString:string="";
        let ZplStrinAray: Array<String> = [];
  
        let fontPositin:number=110, fontSizeMedium = 16, fontXPos=0,seqNumFontZize=24;
        let barcodePosition:number=15;
        let topMargin = 21, leftMargin = 48;
        let barCodeXPos = 0, barCodeYPos = 0, barCodeHeight = 80;
        let printQty = 2, printSpeed = 2, printDarkness = 30;
        let line1Pos=110,line2Pos=128,line3Pos=144,line4Pos=162,seqNumPos=250;
  
        for (const element of printLabelDataTemp) {
  
        ZplString=`^XA
                  ^PR${printSpeed}
                  ~SD${printDarkness}
                  ^LS-${leftMargin}
                  ^LT${topMargin}  
                  ^FO${barCodeXPos},${barCodeYPos}^BCN,${barCodeHeight},Y,N,N,A
                  ^FD${element.BarCode}^FS
                  ^A0,${seqNumFontZize}^FO${seqNumPos},${line1Pos},1^FD${element.RowNumber}^FS
                  ^A0,${fontSizeMedium}^FO${fontXPos},${line1Pos}^FD${element.EquipmentSerialNumber} ${ element.EquipmentSerialNumber && element.EquipmentID ? '|':'' } ${element.EquipmentID} ^FS
                  ^A0,${fontSizeMedium}^FO${fontXPos},${line2Pos}^FD${element.TestDisplayNameShort} ^FS
                  ^A0,${fontSizeMedium}^FO${fontXPos},${line3Pos}^FD${element.ClinicNumber} ${ element.ClinicNumber && element.ContainerDescription ? '|':'' } ${element.ContainerDescription.slice(0,10)}^FS
                  ^A0,${fontSizeMedium}^FO${fontXPos},${line4Pos}^FD${element.ContainerInstructions}^FS               
                                    
                  ^XZ`;
  
                 ZplStrinAray.push(ZplString);
            }
     let  printZPLStringParams={
          "userHostAddress":this.userInfo.userHostAddress,
          "printerShareName": this.userInfo.printerShareName,
          "zebraLabels": ZplStrinAray
     }
     console.log(ZplStrinAray);
     this._requisitionService.printZPL(printZPLStringParams).subscribe(response =>
      {
        if(response.errors){
          let errMessage=this.isPrintFromPendingManifest?"Printer is not available. Please try again when printer is available.":"Printer is not available. Please navigate to the Pending Manifest page to print labels."
         // this._messageService.showAlertMessage("Alert:"+errMessage);

         this._messageService.genericConfirm({
          message: errMessage,
          header: "Alert",
          acceptLabel: "OK",
          rejectVisible:false,
          key:"HideReject"
        },        
        () => {
          this.labelPrintingCompletedEvent.emit(false);
        }
        );
          console.log("printZPLURL error: "+response.errors); 
          //this.labelPrintingCompletedEvent.emit(false);
        }
        else{      
          setTimeout(() => {
            this._messageService.showAlertMessage("Label Printed Successfully.");
          }, 2000);
          console.log("printZPLURL success:"+response);
          this.labelPrintingCompletedEvent.emit(true); 
        }      
          this._loaderService.hide();
          
      },
      (ex)=>
      {
        console.log(ex); 
        ex.error.text
        this._loaderService.hide();
      });
    }    
  }

  chunks(array, size) {
    let results = [];
    results = [];
    while (array.length) {
      results.push(array.splice(0, size));
    }
    return results;
  };

  createPDF() {
    setTimeout(() => {
      try {
        var html = htmlToPdfmake(document.getElementById('printHtml').innerHTML, {
          tableAutoSize: true,
          customTag: function (params) {
            var ret = params.ret;
            var element = params.element;
            var parents = params.parents;
            switch (ret.nodeName) {
              case "NGX-BARCODE": {
                ret = this.applyStyle({ ret: ret, parents: parents.concat([element]) });
                if(ret !=null && ret !=undefined && ret.stack !=null && ret.stack[0].stack !=null){
                  ret.stack[0].stack[0].width = 100;
                  ret.stack[0].stack[0].height = 25;               
                }
                break;
              }
            }
            return ret;
          }
        }
        );
        var dd = {
          pageMargins: [ 0, 0, 0, 0 ],
          // pageSize: {
          //   width: 612,
          //   height: 792
          // },
          pageSize:'LETTER',
          content: html, pageBreakBefore: function (currentNode:any) {
            return currentNode.style && currentNode.style.indexOf('pdf-pagebreak-before') > -1;
          },
          imagesByReference: true,
          // footer: function(currentPage, pageCount) { return currentPage.toString() + ' of ' + pageCount; },
        };

        pdfMake.createPdf(dd).open();
        this.labelPrintingCompletedEvent.emit(true);
      }
      catch (ex) {
        console.log('error in create pdf' + ex);
        this._loaderService.hide();
      }
    }, 2000);


  }
}
